import React from 'react'
import { Container } from 'react-bootstrap'
import cx from "classnames";
import withStyles from 'isomorphic-style-loader/withStyles';
import Skeleton from '../../../Common/Skeleton/Skeleton'
import ProfileCardSkeleton from '../ProfileCardSkeleton/ProfileCardSkeleton'
import PriceDetailsSkeleton from '../PriceDetailsSkeleton/PriceDetailsSkeleton'
import s from './ChatMessageSkeleton.css'

function ChatMessageSkeleton() {
    return (
        <Container>
            <Skeleton className={s.goBackSkeletonBtn} />
            <div className={s.chatMessageSkeletonContainer}>
                <div className={s.chatMessageSkeletonLsBox}>
                    <div className={cx(s.chatMessageSkeletonInputContainer, 'chatMessageBoxRtl')}>
                        <div className={s.chatMessageSkeletonInput} />
                        <Skeleton className={s.chatMessageSkeletonSendIcon} />
                    </div>
                    <div className={s.chatMessageSkeletonMessageContainer}>
                        {[1, 2].map((n) =>
                            <div className={cx(s.chatMessageSkeletonMessageBox, n % 2 === 0 && s.chatMessageSkeletonMessageBoxReverse)}>
                                <Skeleton className={s.chatMessageSkeletonMessageImg} />
                                <Skeleton className={s.chatMessageSkeletonMessageInfo} />
                            </div>
                        )}
                        <div className={s.loaderSkeletonBtnContainer}>
                            <Skeleton className={s.loaderSkeletonBtn} />
                        </div>
                    </div>
                </div>
                <div className={s.chatMessageSkeletonRsBox}>
                    <ProfileCardSkeleton />
                    <PriceDetailsSkeleton />
                </div>
            </div>
        </Container>
    )
}

export default withStyles(s)(ChatMessageSkeleton);
